import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,

  LINK_COLOR: '#1589ee',
  PRIMARY_MAIN: '#fff',
  PAGINATION_BACKGROUND: '#fff',
  BACKGROUND: '#efefef',
  HEADER_COUNT_TEXT: '#373737',
  PRIMARY_CONTRAST: '#373737',
  SECONDARY_MAIN: '#1589ee',
  PUBLIC_HEADERCOLOR: '#061c3f',
  LANGUAGE_SWITCH: '#1589ee',
  BODY_BACKGROUND: '#fff',
  MODAL_BACKGROUND: '#fff',
  MODAL_BORDER: '#d9d9d9',
  MODAL_LINK: '#1589ee',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.3)',
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },
  ACTIVE_ROW: 'rgba(21,137,238,0.31)',
  USER_LOGO_BACKGROUND: '#fff',
  USER_LOGO_COLOR: '#1589ee',

  INPUT_BORDER: IS_ADMIN ? '#8A8B8C' : '#ccc',
  HEADER_COLOR: IS_ADMIN ? '#20263a' : '#1589ee',
  HEADER_TEXT: IS_ADMIN ? '#d3d8df' : '#f4f6f9',
  CHECKBOX_TICK: IS_ADMIN ? '#1589ee' : '#000',
  PAGINATION_COLOR: IS_ADMIN ? '#1589ee' : '#000',
  BACKGROUND_MENU: IS_ADMIN ? '#d3d8df' : '#f4f6f9',

  ...(IS_ADMIN
    ? {
        TERNARY_BORDER: '#8A8B8C',
        LOGIN_BACKGROUND: '#20263a',
        MENU_BACKGROUND: '#061c3f',
        HEADER_INFO_DASHBOARD_COLOR: '#373737',
        HEADER_BG: '#fff',
        LIGHT_BORDER: '#000',
        PRIMARY_BORDER: '#ccc',
        CHIP_BG: '#fff',
        HEADER_COLOR2: '#20263a17',
        FORM_INPUT_BG: '#fff',
        BROWSOR_FOCUS_INPUT_BG: '#000',
        PAGINATION_ALTERNATE_BACKGROUND: 'rgb(239, 239, 239)',
        SELECTED_MENU_TITLE: '#fff',
        SELECTED_MENU_BG: 'rgb(24, 28, 45)',
        MENU_TITLE: '#fff',
        TOOLTIP_COLOR: '#000',
        USER_NAME_COLOR: '#fff',
        LOGOUT_BUTTON: '#1589ee',
        RESELLER_SELECT_COLOR_LAST: '#000',
        RESELLER_SELECT_COLOR_FIRST: '#000',
        INPUT_FOCUS: '#fff',
        ALERT_COLOR: '#ce1e51',
        ALERT_BACKGROUND: '#2a3135',
        DASHBOARD: {
          CARD: '#b9b9ba17',
          COLOR: '#000',
        },
      }
    : {}),

  ...(IS_ADMIN ? {} : {}),
};
export const fonts = ['Source Sans Pro', 'sans-serif'].join(',');
export const filterFont = '14px/1.428 Source Sans Pro';
export const headerFont = '14px';
export const formlabelFont = '18px';
export const subTitle = '14px';
export const titleLabel = '20px';
export const buttonFont = '22px';
export const inputFont = '18px';
export const checkboxFont = '18px';
export const addbuttonFont = '20px';
export const companyDataFont = '20px';
export const iftaReport = '15px';
export const inspectionInput = '17px';
export const inspectionresolution = '14px';
